<div class="logoRegisterContainer h-100vh">
  <div class="flex flex-column justify-content-end">
    <div class="flex flex-grow-1 align-items-center justify-content-center">
      <img src="/assets/images/amigo_logo.svg" alt="Amigo telcel logo" class="filter-blue">
    </div>
    <app-content-main>
      <div class="flex flex-column justify-content-end align-items-center  letra-telcel">
        <h4 class="app-text-blue mt-4 p-chip-text"><b>SOLICITUD DE DESBLOQUEO</b></h4>
        <p class="p-component app-text-blue text-center mt-0">Puedes recuperar tu código con alguno de los siguientes
          datos.</p>
        <div class="flex flex-column align-self-start pl-3 pr-3 w-full">
          <form [formGroup]="dataSolicitudForm" (submit)="respuestaSolicitud()">
            <div class="field p-component app-text-blue mb-1">
              <div class="p-inputgroup mt-2">
                <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
                <input  type="tel" pInputText id="numeroCuenta" class="w-full" formControlName="numeroCuenta" required
                  maxlength="10" pTooltip="Ingresa tu número de cuenta"
                  onkeypress=" return (event.charCode >= 48 && event.charCode <= 57)" placeholder="Número de Cuenta">
              </div>
            </div>
            <div class="field p-component app-text-blue mb-1">
              <div class="p-inputgroup mt-3">
                <span class="p-inputgroup-addon"><i class="pi pi-phone"></i></span>
                <input  type="tel" pInputText id="numeroCelular" class="w-full" formControlName="numeroCelular" required
                  maxlength="10" pTooltip="Ingresa tu número celular a 10 dígitos"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  placeholder="Número Telefónico a 10 dígitos">
              </div>

            </div>
            <div class="field p-component app-text-blue mb-1">
              <div class="p-inputgroup mt-3">
                <span class="p-inputgroup-addon"><i class="pi pi-envelope"></i></span>
                <input type="email" pInputText id="email" class="w-full" formControlName="email"
                  pTooltip="Ej. usuario@dominio.com" placeholder="Escribe tu correo electrónico">
              </div>

            </div>
            <p *ngIf="isVisible" class="p-component app-text-blue text-center mt-5">Si tu equipo muestra una clave de acceso, por favor ingrésala.</p>
            <div *ngIf="isVisible" class="field p-component app-text-blue mb-1">
              <div class="p-inputgroup mt-3">
                <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
                <input type="text" pInputText id="text" class="w-full" formControlName="pinKnos"
                  pTooltip="La clave se visualiza en la parte superior de tu pantalla con la leyenda 'Clave de acceso'" placeholder="Clave de acceso ">
              </div>

            </div>

            <div class=" flex flex-row field p-component mb-4 mt-4 justify-content-center">
              <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" pTooltip="Confirma que no eres un robot"
                formControlName="recaptcha">
              </ngx-recaptcha2>

            </div>
            <div class="flex flex-column mt-3 mb-3">
              <button type="submit" pButton class="primaryButton p-button-sm" label="SOLICITAR CÓDIGO">
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="pl-2 pr-2">
        <p class="text-xs text-center">{{version}}</p>
    </div>

    </app-content-main>
    <p-dialog header="AVISO IMPORTANTE" [(visible)]="displayDialog" [modal]="true" [style]="{width: '70vw'}"
      [draggable]="false" [resizable]="false" [closable]="false">
      <p class="m-0">{{ mensajeDialog }}</p>
      <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="displayDialog=false" label="Cerrar" styleClass="p-button-text"></p-button>
      </ng-template>
    </p-dialog>
  </div>
</div>

<p-dialog header="" [modal]="true" [(visible)]="isvisibleDialogMultiple" [style]="{ width: '40%' }">
  <span class="p-text-secondary block mb-5">Hemos identificado múltiples números de cuenta asociados a su registro.
    Para proceder, le solicitamos que seleccione la cuenta que desea desbloquear. Le recordamos que puede consultar su contrato para identificar el número de cuenta correspondiente..</span>
    <div class="card flex justify-content-center mb-4">
      <select class="" [(ngModel)]="selectedCategory">
        <option selected value="null">Selecciona</option>
        <option *ngFor="let item of multipleData" value="{{item.account}}">{{item.account}}</option>
      </select>
  </div>
  <div class="flex justify-content-end gap-2">
      <p-button label="Cancelar" severity="secondary" (onClick)="isvisibleDialogMultiple = false" />
      <p-button label="Enviar" (onClick)="selectCuenta()" />
  </div>
</p-dialog>

<div *ngIf="spinner">
  <app-loandig></app-loandig>
</div>
